module.exports = __webpack_public_path__ + "static/img/ys_btn2.c2588bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/home/pc/role3/control/ys_btn2.png
// module id = jY1s
// module chunks = 7